/* eslint-ignore */
// @ts-nocheck
import { getMonth, getYear } from 'date-fns';
import ptBr from 'date-fns/locale/pt';
import React, { useEffect, useMemo, useState } from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker-cssmodules.css';
import 'react-datepicker/dist/react-datepicker.css';
import { FaRegCalendar } from 'react-icons/fa';
import { IoMdArrowDropleft, IoMdArrowDropright } from 'react-icons/io';
import ReactInputMask from 'react-input-mask';
import useWindowSize from '~/hooks/windowSize';
import theme from '~/styles/theme';
import {
  Container,
  Content,
  ErrorText,
  ButttonArrow,
  CalendarHeaderOptions,
} from './styles';

registerLocale('ptBr', ptBr);

const DatePickerField = ({
  errorMessage,
  errorCondition,
  borderHighlightColor = theme.colors.lightBlue,
  disabled,
  LeadingIcon,
  TrailingIcon = () => <FaRegCalendar size={24} />,
  startDate = null,
  styles = null,
  abastecimento = false,
  ...rest
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const [isErrored, setIsErrored] = useState(false);
  const [startDateComponent, setStartDate] = useState(startDate);

  const months = useMemo(() => [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro',
  ]);

  const years = useMemo(() => {
    const defaulYear = getYear(new Date());
    const yearList = [];
    for (let index = 0; index <= 150; index++) {
      yearList.push(defaulYear - index);
    }
    return yearList;
  });

  useEffect(() => {
    setIsErrored(!!errorCondition);
  }, [errorCondition]);

  const randomId = useMemo(() => {
    const text = '';
    return `${text.replace(/\s/g, '')}-${Math.floor(Math.random() * 100)}`;
  }, []);

  const [width, height] = useWindowSize();

  return (
    <>
      <Container
        isFocused={isFocused}
        isErrored={isErrored}
        borderHighlightColor={borderHighlightColor}
        disabled={disabled}
        customStyles={styles && styles.container}
      >
        {LeadingIcon && <LeadingIcon />}
        <Content abastecimento={abastecimento}>
          <DatePicker
            styles={{ '&:hover': { cursor: 'pointer' } }}
            locale="ptBr"
            disabled={disabled}
            selected={startDateComponent}
            onChange={(date) => setStartDate(date)}
            withPortal={width <= 768 || height <= 650}
            dateFormat="dd/MM/yyyy"
            onCalendarOpen={() => setIsFocused(true)}
            onCalendarClose={() => setIsFocused(false)}
            customInput={<ReactInputMask mask="99/99/9999" />}
            strictParsing
            {...rest}
            renderCustomHeader={({
              date,
              changeYear,
              changeMonth,
              decreaseMonth,
              increaseMonth,
              prevMonthButtonDisabled,
              nextMonthButtonDisabled,
            }) => (
              <CalendarHeaderOptions>
                <ButttonArrow
                  type="button"
                  onClick={decreaseMonth}
                  disabled={prevMonthButtonDisabled}
                >
                  <IoMdArrowDropleft size={24} />
                </ButttonArrow>
                <select
                  value={getYear(date)}
                  onChange={({ target: { value } }) => changeYear(value)}
                >
                  {years.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>

                <select
                  value={months[getMonth(date)]}
                  onChange={({ target: { value } }) =>
                    changeMonth(months.indexOf(value))
                  }
                >
                  {months.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>

                <ButttonArrow
                  type="button"
                  onClick={increaseMonth}
                  disabled={nextMonthButtonDisabled}
                >
                  <IoMdArrowDropright size={24} />
                </ButttonArrow>
              </CalendarHeaderOptions>
            )}
          />
        </Content>
        {TrailingIcon && <TrailingIcon />}
      </Container>
      {errorMessage && errorCondition && (
        <ErrorText aria-hidden="true" id={`control-${randomId}`}>
          {' '}
          {errorMessage}
        </ErrorText>
      )}
    </>
  );
};

export default DatePickerField;
